module.exports = __webpack_public_path__ + "img/navbg.dbf8343e.jpg";